import { LINKS } from "@silo/types";
import { BreakdownCollateral } from "../../apr-display-v2/breakdown/breakdown-collateral";
import { DescriptionExternalLink } from "../../description";
import { KeyValueList } from "../../key-value-list";
import { TotalApr } from "./total-apr";
import { CollateralMetrics } from "./types";
import { DepositCurrentAprDescription } from "../descriptions";

interface CurrentAprProps {
  currentMetrics: CollateralMetrics;
}

export function CurrentApr({ currentMetrics }: CurrentAprProps): JSX.Element {
  const {
    hasCollateralRewards,
    collateralBaseApr,
    collateralRewards,
    totalCollateralApr,
  } = currentMetrics;

  return (
    <KeyValueList.Pair
      description={<DepositCurrentAprDescription />}
      trailingContent={
        hasCollateralRewards ? (
          <BreakdownCollateral
            className="gap-0 text-sm"
            collateralRewards={collateralRewards}
            collateralBaseApr={collateralBaseApr}
            align="right"
          />
        ) : undefined
      }
      trailingContentContainerClassName="gap-0"
    >
      <KeyValueList.Key>Current APR</KeyValueList.Key>

      <KeyValueList.Value>
        <TotalApr
          hasCollateralRewards={hasCollateralRewards}
          totalCollateralApr={totalCollateralApr}
        />
      </KeyValueList.Value>
    </KeyValueList.Pair>
  );
}
